






















































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import RenderRole from '@/components/render/RenderRole.vue'
import {Role} from '@/enums/Role'
import {UIStateMenu} from '@/enums/UIStateMenu'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'

@Component({
  components: {RenderRole},
})
export default class NavigationMenu extends Vue {
  @Getter('auth/token') token!: string
  @Getter('auth/responsavel') user!: Responsavel
  @Getter('auth/role') role!: Role
  @Getter('auth/usuario') usuario!: ResponsavelUsuario
  @Action('auth/signOut') signOut!: Function
  @Action('auth/changeResponsavel') changeResponsavel!: Function
  @Action('refreshView') refreshView!: Function

  Role = Role
  UIStateMenu = UIStateMenu
  Helper = Helper
  currentMenuState = UIStateMenu.HIDDEN

  get userName() {
    let nomeUsuario = Helper.getUsuarioNome()
    if (nomeUsuario === '') {
      nomeUsuario = Helper.getAdminNome()
    }
    return nomeUsuario
  }

  get caretRotated() {
    return [
      this.currentMenuState === UIStateMenu.MANAGE,
      this.currentMenuState === UIStateMenu.REPORTS,
      this.currentMenuState === UIStateMenu.PROFILE_MENU,
    ]
  }

  get routeBelongsManage() {
    return !!this.$route.path.match(/^\/manage\/.+/g)
  }

  get routeBelongsReports() {
    return !!this.$route.path.match(/^\/reports\/.+/g)
  }

  async switchState(state: UIStateMenu) {
    const oldState = this.currentMenuState

    if (oldState !== UIStateMenu.HIDDEN) await Helper.sleep(20)

    // Wait the next render
    await this.$nextTick()

    if (oldState === state) {
      this.killState(false)
    } else {
      this.currentMenuState = state
    }
  }

  killState(refresh = true) {
    this.currentMenuState = UIStateMenu.HIDDEN
    if (refresh) {
      this.refreshView()
    }
  }
}
